<h2 mat-dialog-title>{{ 'client.request_client_dialog.title' | transloco }}</h2>
<mat-dialog-content>
	<p style="padding-bottom: 1rem">
		{{ 'client.request_client_dialog.message' | transloco: { firstName: client.firstName, lastName: client.name } }}
	</p>

	<form [formGroup]="form">
		<p id="radio-group-label">{{ 'client.request_client_dialog.choose_assignment_type' | transloco }}</p>
		<mat-radio-group aria-labelledby="radio-group-label" formControlName="assignmentType" class="radio-group">
			<mat-radio-button class="radio-button" [value]="AssignmentRequestType.Main">{{
				'client.request_client_dialog.main' | transloco
			}}</mat-radio-button>
			<mat-radio-button class="radio-button" [value]="AssignmentRequestType.Fds">{{
				'client.request_client_dialog.fds' | transloco
			}}</mat-radio-button>
		</mat-radio-group>

		@let dateCtrl = form.controls.date;
		<lvr-field [label]="'client.request_client_dialog.date' | transloco | appendAsterisk">
			<mat-form-field
				lvrInput
				[lvrError]="hasError(dateCtrl, 'matDatepickerParse', 'matDatepickerMin', 'matDatepickerMax', 'required')"
			>
				<input
					matInput
					[matDatepicker]="picker"
					formControlName="date"
					placeholder="01.07.2025"
					[errorStateMatcher]="matcher"
					[min]="minDate()"
					[max]="maxDate()"
				/>
				@if (hasError(dateCtrl, 'matDatepickerParse')) {
					<mat-error>{{ 'base.form.error.date_format_invalid' | transloco: { format: dateFormatHint } }}</mat-error>
				} @else if (hasError(dateCtrl, 'matDatepickerMin')) {
					<mat-error>{{
						'base.form.error.date_min_error' | transloco: { minDate: (minDate() | date: dateDisplayFormat) }
					}}</mat-error>
				} @else if (hasError(dateCtrl, 'matDatepickerMax')) {
					<mat-error>{{ 'base.form.error.date_max_error' | transloco }}</mat-error>
				} @else if (hasError(dateCtrl, 'required')) {
					<mat-error>{{ 'base.form.error.required' | transloco }}</mat-error>
				} @else {
					<mat-hint>{{ dateFormatHint }}</mat-hint>
				}
				<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
				<mat-datepicker #picker></mat-datepicker>
			</mat-form-field>
		</lvr-field>

		@let reasonCtrl = form.controls.reason;
		<lvr-field [label]="'client.request_client_dialog.reason' | transloco">
			<mat-form-field lvrInput [lvrError]="hasError(reasonCtrl, 'max')">
				<textarea
					matInput
					formControlName="reason"
					[placeholder]="'client.request_client_dialog.reason_placeholder' | transloco"
					[errorStateMatcher]="matcher"
					[maxlength]="textareaMaxLength"
				></textarea>
				@if (hasError(reasonCtrl, 'max')) {
					<mat-error>{{ 'base.form.error.max_length_exceeded' | transloco: { max: textareaMaxLength } }}</mat-error>
				}
				<mat-hint>{{
					'base.field.remark_hint' | transloco: { actual: reasonCtrl.value.length || 0, max: textareaMaxLength }
				}}</mat-hint>
			</mat-form-field>
		</lvr-field>

		<mat-dialog-actions class="actions-row">
			<lvr-button
				variant="secondary"
				[label]="'base.button.cancel' | transloco"
				[type]="'button'"
				(clicked)="self.close()"
				icon="disabled_by_default"
			>
			</lvr-button>
			<lvr-button
				variant="primary"
				[label]="'client.request_client_dialog.confirm' | transloco"
				[type]="'button'"
				[disabled]="form.invalid"
				(clicked)="submit()"
				icon="forward_to_inbox"
			>
			</lvr-button>
		</mat-dialog-actions>
	</form>
</mat-dialog-content>
